/*
 * 接口统一集成模块
 */
import * as login from './moudules/sys/login'
import * as menu from './moudules/sys/menu'
import * as article from './moudules/info/article'
import * as perm from './moudules/sys/perm'
import * as user from './moudules/sys/user'
import * as role from './moudules/sys/role'
import * as push from './moudules/sys/push'
import * as exam from './moudules/base/exam'
import * as area from './moudules/base/area'
import * as agent from './moudules/base/agent'
import * as province from './moudules/base/province'
import * as segment from './moudules/base/segment'
import * as ticket from './moudules/aff/ticket'
import * as rule from './moudules/aff/rule'
import * as arrange from './moudules/aff/arrange'
import * as student from './moudules/app/student'
import * as order from './moudules/wish/order'
import * as score from './moudules/app/score'
import * as print from './moudules/aff/print'
import * as base from './moudules/sys/base'
import * as quartz from './moudules/sys/quartz'
import * as code from './moudules/wish/code'
import * as school from './moudules/wish/school'
import * as prof from './moudules/wish/prof'
import * as live from './moudules/wish/live'
import * as wish from './moudules/wish/wish'
import * as data from './moudules/wish/data'
import * as source from './moudules/wish/source'
import * as wishUser from './moudules/wish/user'
import * as remark from './moudules/wish/remark'
import * as customize from './moudules/customize/carousel'
import * as olExam from './moudules/olExam/olExam'
import * as poster from './moudules/base/poster'
import * as channel from './moudules/base/channel'
import * as partners from './moudules/base/partners'
import * as keyWord from './moudules/sys/keyword'
import * as Tkinfo from './moudules/dataManage/tkinfo'
import * as Provincetj from './moudules/dataManage/provincetj'
import * as Xkinfo from './moudules/dataManage/xkinfo'
import * as Examplaceinfo from './moudules/dataManage/xkexamplace'
import * as ZlInfo from './moudules/dataManage/zlinfo'
import * as TDInfo from './moudules/dataManage/tdInfo'
import * as ProfRemark from './moudules/dataManage/profremark'
import * as ProfInfo from './moudules/dataManage/profinfo'
import * as Onlinschool from './moudules/dataManage/onlinschool'
import * as TxExamType from './moudules/dataManage/txexamtype'
import * as ProfPredict from './moudules/dataManage/profpredict'
import * as SchoolPredict from './moudules/dataManage/schoolPredict'
import * as SegmentTable from './moudules/dataManage/segmentTable'
import * as ProvinceBatch from './moudules/dataManage/provinceBatch'
import * as ProvinceBatchLine from './moudules/dataManage/provincebatchline'
import * as ProvinceScoreLine from './moudules/dataManage/provincescoreline'
import * as SchoolRank from './moudules/dataManage/schoolrank'
import * as ProvinceAos from './moudules/dataManage/provinceaos'
import * as Region from './moudules/dataManage/region'
import * as ProfDetail from './moudules/dataManage/profdetail'
import * as TKCateProf from './moudules/dataManage/tkcategoryprof'
import * as Occupation from './moudules/dataManage/occupation'
import * as Salary from './moudules/dataManage/salary'
import * as Algorithm from './moudules/dataManage/algorithm'
import * as FormulaAnaly from './moudules/dataManage/formulaAnaly'
import * as ImportBatch from './moudules/dataManage/importBatch'
import * as ProfLevel from './moudules/dataManage/proflevel'
import * as Profexamcategory from './moudules/dataManage/profexamcategory'
import * as Enrollformula from './moudules/dataManage/enrollformula'
import * as Sameprof from './moudules/dataManage/sameprof'
import * as Smallscorelimit from './moudules/dataManage/smallscorelimit'
// import * as AbroadOrder from '../components/Manager/Wish/AbroadOrder'
import * as Userperm from '../components/Manager/Base/Userperm'
import * as userperm from './moudules/base/userperm'
import * as Partners from '../components/Manager/Base/Partners'
import * as schoolProf from './moudules/dataManage/SchoolProf'
import * as SchoolProf from '../components/Manager/Tkinfo/SchoolProf'
import * as SchoolExamSchool from '../components/Manager/Tkinfo/SchoolExamSchool'
import * as Schoolexamcalendar from '../components/Manager/Tkinfo/Schoolexamcalendar'
import * as teacher from './moudules/adroad/teacher'
import * as abroadAgent from './moudules/adroad/agent'
import * as abroadCountry from './moudules/adroad/country'
import * as abroadUser from './moudules/adroad/user'
import * as chineseForeign from './moudules/adroad/chineseForeign'
import * as direction from './moudules/adroad/direction'
import * as SchoolType from './moudules/dataManage/schooltype'
import * as crm from './moudules/crm/crm'
import * as group from './moudules/crm/group'
import * as auth from './moudules/tiktok/auth'
import * as bind from './moudules/tiktok/bind'
import * as employee from './moudules/tiktok/employee'
import * as entiry from './moudules/tiktok/entiry'
import * as material from './moudules/tiktok/material'
import * as mount from './moudules/tiktok/mount'
import * as coursetiktok from './moudules/tiktok/coursetiktok'
import * as reparticle from './moudules/reptile/reparticle'
import * as replog from './moudules/reptile/replog'
import * as website from './moudules/reptile/website'
import * as accarticle from './moudules/reptile/accarticle'
import * as accounts from './moudules/reptile/accounts'
import * as partype from './moudules/base/partype'
import * as collectionschool from './moudules/info/collectionschool'
import * as schedule from './moudules/info/schedule'
import * as exceptions from './moudules/dataManage/exceptions'
import * as websiteInfo from './moudules/wish/website'
import * as trans from './moudules/trans/index'

// 默认全部导出
export default {
    login,
    menu,
    article,
    perm,
    push,
    user,
    role,
    exam,
    area,
    agent,
    province,
    segment,
    ticket,
    rule,
    arrange,
    student,
    order,
    score,
    print,
    base,
    quartz,
    code,
    school,
    prof,
    wish,
    wishUser,
    customize,
    live,
    source,
    olExam,
    poster,
    channel,
    partners,
    keyWord,
    Tkinfo,
    Xkinfo,
    Provincetj,
    Examplaceinfo,
    ZlInfo,
    TDInfo,
    remark,
    ProfRemark,
    ProfInfo,
    Onlinschool,
    TxExamType,
    ProfPredict,
    SchoolPredict,
    SegmentTable,
    ProvinceBatch,
    ProvinceBatchLine,
    ProvinceScoreLine,
    SchoolRank,
    ProvinceAos,
    Region,
    ProfDetail,
    TKCateProf,
    Occupation,
    Salary,
    Algorithm,
    FormulaAnaly,
    ImportBatch,
    ProfLevel,
    Profexamcategory,
    Enrollformula,
    Sameprof,
    Smallscorelimit,
    // AbroadOrder,
    Userperm,
    userperm,
    Partners,
    schoolProf,
    SchoolProf,
    SchoolExamSchool,
    Schoolexamcalendar,
    teacher,
    abroadAgent,
    abroadCountry,
    abroadUser,
    chineseForeign,
    SchoolType,
    direction,
    crm,
    data,
    group,
    auth,
    bind,
    employee,
    entiry,
    material,
    mount,
    coursetiktok,
    reparticle,
    replog,
    website,
    accarticle,
    accounts,
    partype,
    collectionschool,
    schedule,
    exceptions,
    websiteInfo,
    trans
}



// WEBPACK FOOTER //
// ./src/http/api.js